import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { padSlides } from "../simplerToolkit.js";

document.addEventListener('DOMContentLoaded', () => {
    const carousels = Array.from(document.querySelectorAll('section.image-navigation .swiper'));
    if (!carousels.length) return;

    carousels.forEach((el) => {
        const prev = el.parentElement?.parentElement?.querySelector('.swiper-button-prev')
            || el.parentElement?.querySelector('.swiper-button-prev');
        const next = el.parentElement?.parentElement?.querySelector('.swiper-button-next')
            || el.parentElement?.querySelector('.swiper-button-next');
        const pagination = el.querySelector('.swiper-pagination');

        // Pad slides if slides are 8 or less.
        padSlides(el, 8);

        const swiperInstance = new Swiper(el, {
            modules: [Navigation, Pagination],
            slidesPerView: 1.25,
            spaceBetween: 16,
            centeredSlides: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            loopedSlides: 4,
            loop: true,
            keyboard: {
                enabled: true,
                onlyInViewport: true,
            },

            mousewheel: {
                forceToAxis: true,
                sensitivity: 1,
            },
            breakpoints: {
                650: {slidesPerView: 2.25, spaceBetween: 16},
                768: {slidesPerView: 3.25, spaceBetween: 20},
                1024: {slidesPerView: 4, spaceBetween: 24},
            },
            // navigation: prev && next ? {prevEl: prev, nextEl: next} : undefined,
            navigation: false,
            pagination: pagination ? {el: pagination, clickable: true} : undefined,
        });

        setTimeout(() => {
            swiperInstance.update();
        }, 50);
    });
});
